var encoders = exports;

encoders.der = require('./der');
encoders.pem = require('./pem');



//////////////////
// WEBPACK FOOTER
// ../~/asn1.js/lib/asn1/encoders/index.js
// module id = 342
// module chunks = 0